module.exports = __webpack_public_path__ + "static/media/logo-TT-V.576d54b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo-TT-V.png
// module id = 545
// module chunks = 0